import { SelectedLocationType } from 'src/app/enums/selected-location-type.enum';
import { pscMenuItemsGroup } from 'src/app/components/side-bar/consts/pcs-menu-items-group.const';
import { iopMenuItemsGroup } from './iop-menu-items-group.const';
import { SideBarMenuItemGroup } from 'src/app/models/side-bar-menu-item-group';
import { pscHomeMenuItemsGroup } from 'src/app/components/side-bar/consts/pcs-home-menu-items-group.const';

export const menuItemGroupsMap: Record<SelectedLocationType, SideBarMenuItemGroup[]> = {
  [SelectedLocationType.PscSwitched]: pscMenuItemsGroup,
  [SelectedLocationType.Iop]: iopMenuItemsGroup,
  [SelectedLocationType.PscHome]: pscHomeMenuItemsGroup
};
